import { container } from "tsyringe";
import { EditorSettingsService } from "./designs/settings/EditorSettingsService";

container.register<EditorSettingsService>("EditorSettingsService", { useClass: EditorSettingsService });
